import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, LinearProgress, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const WIDTHS = { compact:500, small:600, standard:900, wide:1200, extraWide:1500 };

export default function ETVPopup({
  open,
  onClose,
  width='standard',
  icon,
  title,
  description,
  loading=false,
  topActions,
  bottomActions,
  children,
  closeButton=true,
  contentSx,
  dialogProps,
}) {
  const popupWidth=WIDTHS[width] || WIDTHS.standard;
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth={false} {...dialogProps}
    PaperProps={{sx:{width:`min(calc(100vw - 32px), ${popupWidth}px)`,maxWidth:'none',borderRadius:4,overflow:'hidden'}}}>
    <DialogTitle component="div" sx={{p:{xs:2,md:2.5}}}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1.25} sx={{minWidth:0}}>
          {icon && <Box sx={{display:'flex',color:'primary.main',flexShrink:0}}>{icon}</Box>}
          <Box sx={{minWidth:0}}>
            <Typography variant="h6" fontWeight={700}>{title}</Typography>
            {description && <Typography variant="body2" color="text.secondary" sx={{mt:0.25}}>{description}</Typography>}
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {topActions}
          {closeButton && <IconButton aria-label="Close" onClick={onClose}><CloseIcon/></IconButton>}
        </Stack>
      </Stack>
    </DialogTitle>
    <Divider/>
    {loading && <LinearProgress/>}
    <DialogContent sx={{p:{xs:2,md:2.5},...contentSx}}>{children}</DialogContent>
    {bottomActions && <><Divider/><DialogActions sx={{p:{xs:2,md:2.5},gap:1}}>{bottomActions}</DialogActions></>}
  </Dialog>;
}
